import { type MutationHookOptions, useMutation } from '@apollo/client';
import { useCallback } from 'react';
import type { CreateTagLayoutMutation, CreateTagLayoutMutationVariables } from 'types/graphql';
import { CREATE_TAG_LAYOUT, CREATE_TAG_LAYOUT_FROM_EDITOR } from '../tagLayouts.api';

/** Which screen saves. Each keeps its own operation name (telemetry), so the hook selects the document. */
export type TagLayoutSurface = 'list' | 'editor';

const CREATE_BY_SURFACE = { list: CREATE_TAG_LAYOUT, editor: CREATE_TAG_LAYOUT_FROM_EDITOR } as const;

/** `createTagLayout` (P7-R2) over the surface's unchanged document. */
export function useCreateTagLayout(
  surface: TagLayoutSurface,
  options?: MutationHookOptions<CreateTagLayoutMutation, CreateTagLayoutMutationVariables>
) {
  const [mutate, { loading, error }] = useMutation<CreateTagLayoutMutation, CreateTagLayoutMutationVariables>(
    CREATE_BY_SURFACE[surface],
    options
  );
  const create = useCallback((variables: CreateTagLayoutMutationVariables) => mutate({ variables }), [mutate]);
  return { create, loading, error };
}
